import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance, initializeMsalInstance } from './auth/msalInstance';
import './index.css';
import App from './App';

// Create a QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: (failureCount, error) => {
        // Don't retry authentication errors
        if (error?.message?.includes('Authentication') || error?.message?.includes('No authenticated account')) {
          return false;
        }
        // Don't retry auth/authorization errors (401/403) - they won't succeed on
        // retry and just churn the UI (e.g. a token audience/config mismatch).
        if (error?.status === 401 || error?.status === 403) {
          return false;
        }
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
    },
  },
});

async function bootstrap() {
  await msalInstance.initialize();
  initializeMsalInstance();

  const root = ReactDOM.createRoot(document.getElementById('root'));

  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </MsalProvider>
    </React.StrictMode>
  );
}

bootstrap();
